export default function PolicyCostData() {
    return {
        text: {
                title: "How much will your policy cost",
                paragraphs: [
                 'There are several factors that determine your price for coverage. The main price components are based upon your age, gender, health and medical background and coverage amount. All of these factors are used to determine premium.',
                 'However, every insurance company has different policy features and pricing. It’s important to review options to fit your specific needs and budget.',
                 'Our licensed, non-commissioned experts have your best interests in mind and will help you secure the right company and coverage.',
              ],
            },
        callToActionText: "CONTINUE",
        image: "/product-landing/term/policy-cost.jpg",
    }
}